import React, { Component } from 'react';
import {Button} from 'primereact/components/button/Button';


class AiOptionButton extends Component { 

    render() {
//       console.log('renderOption',this.props.active,this.props.attr,this.props.value);
        let emptyPrefix = this.props.namePrefix === undefined ? ' ai-empty-prefix':'';
       //console.log('emptyPrefix',this.props);
       var newcat= this.props.optionsName
       if (newcat ==='acharm' && this.props.optionsCat  === '5'&& this.props.sku==='9000')
         newcat+='-5'
       else  if (newcat ==='acharm' && this.props.optionsCat  === '5'&& this.props.sku!=='9000')
         newcat+='-10'
       else if (newcat ==='acharm' && this.props.optionsCat  === '2')
         newcat+='-2'
         else if (newcat ==='acharm' && this.props.optionsCat  === '11')
         newcat+='-11'
         else if (newcat ==='acharm' && this.props.optionsCat  === '12')
         newcat+='-12'
         else if (newcat ==='acharm' && this.props.optionsCat  === '3')
         newcat+='-3'
  //  console.log('size name',this.props.sizeName);
         
    if (newcat === 'acust' &&  this.props.optionNumber===2   )
    {
      var label2 =this.props.name
      if (label2 === 'Choose Chain' && this.props.chainm !== '-1')
        label2 ='Chain'
     if (label2 === 'Choose Locket' && (this.props.chainm !== '-1' &&  this.props.locket !== '-1'))
        label2 ='Locket'
     return(<Button  key={"acust-"+this.props.name} className={"ai-acust "+ this.props.buttonselect}   value={this.props.activetype} onClick={()=>this.props.onClick(this.props.cur_ga_event)} label={label2}></Button>)
    } 
    else if (newcat === 'acust')     
     return(<Button  key={"acust-"+this.props.name} className={"ai-acust "+ this.props.buttonselect}   value={this.props.activetype} onClick={()=>this.props.onClick(this.props.cur_ga_event)} label={this.props.name}></Button>)
    else
     return (
        <div style={{width:this.props.optionSize,height:this.props.optionSize,float:'left'}} 
        onClick={()=>this.props.onClick(this.props.cur_ga_event)}
        disabled={this.props.active}
        className={'ai-option-button '+this.props.show +' '+this.props.select +' ai-option-button-'+this.props.optionSize }
        >
        <div className='ai-border-box'> 
        <i className={'ai-check-icon fa '+this.props.select}/>
        <div className={'ai-button-text-top-'+newcat + this.props.notext + ' ai-button-text-top '+this.props.selectText  + ' ' +this.props.horoscopeText+'2' }>{this.props.nameTop}</div>
        <img className={'ai-button-image ai-button-image-'+newcat} src={this.props.image} alt={this.props.name}
         srcSet={`${this.props.image} 1x,${this.props.image2} 2x`}
        />
        <div className={'ai-button-text-prefix '+this.props.selectText + ' ' +this.props.horoscopeText} >{this.props.namePrefix}</div>
        <div className={'ai-button-text '+this.props.selectText + emptyPrefix}>{this.props.name}</div>
        <div className={'corner '+this.props.select}/>
        </div>
        </div>
        );  
    }
}

  
export default AiOptionButton;



// WEBPACK FOOTER //
// ./src/layout/AiOptionButton.js